import { useEffect, useState } from "react";

const TTLStreamContent = ({sku, brand, locale}) => {
  const [content, setContent] = useState(null)
  useEffect(() => {
    if (typeof window !== "undefined") {
      const script = document.createElement("script");
      script.src = "//content.24ttl.stream/widget.js";
      script.async = true;

      script.onload = () => {
        window.ttlStream = new window.TTLStream({});
        window.ttlStream
          .find({
            brand: brand,
            productId: sku,
            retailerDomain: "almanea.sa",
            templateType: "master_template",
            resultType: "html",
            contentType: "minisite",
            language: `sa_${locale}`,
          })
          .then((data) => {
            console.log("Content found:", data);
            setContent(data);
          })
          .catch((error) => {
            setContent(null);
            console.error("Error finding content:", error);
          });
      };
      document.body.appendChild(script);
      return () => {
        document.body.removeChild(script);
      };
    }
  }, [sku, brand, locale]);

  return content && <div dangerouslySetInnerHTML={{__html: content}} id="ttl-stream-content"/>
};

export default TTLStreamContent;
